import { render, staticRenderFns } from "./medidas-prevencion-control.vue?vue&type=template&id=1704b75a&scoped=true&"
import script from "./medidas-prevencion-control.vue?vue&type=script&lang=js&"
export * from "./medidas-prevencion-control.vue?vue&type=script&lang=js&"
import style0 from "./medidas-prevencion-control.vue?vue&type=style&index=0&id=1704b75a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704b75a",
  null
  
)

export default component.exports